import { PropsWithChildren, useEffect } from "react";
import { createPortal } from "react-dom";
import { Title } from "../layout";
import Icon from "../icon/Icon";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  className?: string;
}

const Modal = ({
  isOpen,
  onClose,
  children,
  title,
  className,
}: PropsWithChildren<ModalProps>) => {
  // Handle disable scroll behind the modal
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden"; // Lock scroll
    } else {
      document.body.style.overflow = ""; // Restore scroll
    }

    return () => {
      document.body.style.overflow = ""; // Cleanup on unmount
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const modalRoot = document.getElementById("modal-root");
  if (!modalRoot) {
    console.error("modal-root element not found");
    return null;
  }

  return createPortal(
    <div className="modal">
      <div className="modal-backdrop" onClick={onClose}>
        <div
          className={`modal-content${className ? ` ${className}` : ""}`}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="modal-header">
            {title ? <Title title={title} /> : <div />}
            <Icon
              name="close"
              size="big"
              onClick={onClose}
              className="cursor-pointer"
            />
          </div>
          {children}
        </div>
      </div>
    </div>,
    modalRoot,
  );
};

export default Modal;
